import { render, staticRenderFns } from "./pivot.vue?vue&type=template&id=d6e2451a"
import script from "./pivot.vue?vue&type=script&lang=js"
export * from "./pivot.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports